module.exports = __webpack_public_path__ + "media/images/backto-square-one-22327e45040598336c43b134c428e81e.png";